import React from 'react';
import { connect } from 'react-redux';
import * as reducers from '../../store/reducers';

import Form from 'Components/Form';
import FormNote from 'Components/FormNote';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

class StudentLoginForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showUsernameForm: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.accessCode !== this.props.accessCode &&
      typeof nextProps.accessCode === 'string'
    ) {
      window.setTimeout(() => {
        this.setState({ showUsernameForm: true });
      }, 500);
    }
  }

  render() {
    if (this.state.showUsernameForm) {
      return (
        <Form
          type="studentLogin"
          id="studentLogin"
          formStyle="login"
          initialFieldSettings={{
            accessCode: { value: this.props.accessCode },
          }}
          messageFormat="inline"
          submitButtonType="primary"
        />
      );
    } else {
      const formNote = (
        <FormNote
          title={
            <ConnectedFormattedMessage id="form.note.studentSchoolCode.title" />
          }
          text={
            <ConnectedFormattedMessage id="form.note.studentSchoolCode.text" />
          }
          style="two-lines"
        />
      );
      return (
        <Form
          type="studentSchoolCode"
          id="studentSchoolCode"
          formStyle="login"
          messageFormat="inline"
          submitButtonType="primary"
          animationType="persist"
          formNote={formNote}
        />
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    accessCode: reducers.getValidatedSchoolCode(state),
  };
};

export default connect(mapStateToProps, false)(StudentLoginForm);
